import React, { useContext } from 'react'
import styled from 'styled-components'
import { IUser } from '@giphy/js-types'
import { ContentBlockContext } from './../context'
import Icon from './block-icon'

export const Container = styled.div`
    align-items: center;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    font-size: 14px;
    font-weight: bold;
    height: 28px;
    padding: 0 3px 0 0;
    position: relative;
    text-align: left;
    width: 100%;

    &:before {
        content: '';
        display: block;
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }
`

const Label = styled.div`
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 8px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

type Props = {
    label: string
    user?: IUser
}

const ContentBlockLabel = ({ label, user }: Props) => {
    const { labelColor } = useContext(ContentBlockContext)
    return (
        <Container style={{ backgroundColor: labelColor }}>
            <Label>{label}</Label>
            <Icon user={user} />
        </Container>
    )
}

export default ContentBlockLabel
